export const TAB = 'Tab';
export const ENTER = 'Enter';
export const NUMPAD_ENTER = 'NumpadEnter';
export const ESCAPE = 'Escape';
export const ARROW_UP = 'ArrowUp';
export const ARROW_DOWN = 'ArrowDown';
export const BACKSPACE = 'Backspace';
export const DELETE = 'Delete';
/** Used by Event.key */
export const SPACE_KEY = ' ';
/** Used by Event.code */
export const SPACE_CODE = 'Space';
export const ANY_ENTER = [ENTER, NUMPAD_ENTER];

export const isAnyEnter = (code: string): boolean => ANY_ENTER.includes(code);
export const isEnterOrSpace = (key: string): boolean =>
  [ENTER, SPACE_KEY].includes(key);
